import {useApi} from "../Api";
import {
    AncillaryExceptionEntityRequest,
    AncillaryExceptionEntityResponse,
    FormSearchAncillaryExceptionModel
} from "../types/ancillaryException";
import {PagedResponse} from "../types/pagination";
import {buildQueryParams} from "../../utils";

export const useAncillaryExceptionRepository = () => {
    const {GET, POST, PUT, DELETE} = useApi();

    const PATH = "/pricing/ancillary-exception";

    function getAncillaryException(ancillaryExceptionId: number): Promise<AncillaryExceptionEntityResponse> {
        return GET(`${PATH}?id=${ancillaryExceptionId}`);
    }

    function getAncillaryExceptionsByExceptionListAndCommercialCategory({exceptionListId, commercialCategoryId}: {
        exceptionListId: number,
        commercialCategoryId: string
    }): Promise<AncillaryExceptionEntityResponse[]> {
        return GET(`${PATH}/eligible-for-aggregate?exceptionListId=${exceptionListId}&commercialCategoryId=${commercialCategoryId}`);
    }

    function getAncillaryExceptionInUse(ancillaryExceptionId: number): Promise<boolean> {
        return GET(`${PATH}/in-use?ancillaryExceptionId=${ancillaryExceptionId}`);
    }

    function getAncillaryExceptionsPaged(filters: FormSearchAncillaryExceptionModel): Promise<PagedResponse<AncillaryExceptionEntityResponse>> {
        const query = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH}/filter${queryParams ? query + queryParams : ""}`);
    }

    function putAncillaryException(ancillaryException: AncillaryExceptionEntityResponse): Promise<AncillaryExceptionEntityResponse> {
        return PUT(`${PATH}`, ancillaryException);
    }

    function postAncillaryException(ancillaryException: AncillaryExceptionEntityRequest): Promise<AncillaryExceptionEntityResponse> {
        return POST(`${PATH}`, ancillaryException);
    }

    function deleteAncillaryException(ancillaryExceptionId: number): Promise<string> {
        return DELETE(`${PATH}?id=${ancillaryExceptionId}`);
    }

    function terminateAncillaryException(ancillaryExceptionId: number): Promise<AncillaryExceptionEntityResponse> {
        return GET(`${PATH}/terminate?id=${ancillaryExceptionId}`);
    }

    return {
        getAncillaryException,
        putAncillaryException,
        postAncillaryException,
        deleteAncillaryException,
        getAncillaryExceptionsPaged,
        getAncillaryExceptionsByExceptionListAndCommercialCategory,
        getAncillaryExceptionInUse,
        terminateAncillaryException
    };

};

